import React from "react";
import { MotifToast } from "@ey-xd/motif-react";
import "./outage.scss";
import warningIcon from "../../common/images/warningIcon.svg";
import { getUserTimezoneAbbr } from "../../common/utility/utility";

const MONTH_NAMES = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

// Formats an ISO/UTC date string as "20 June 2026, 00:00 IST" in the user's local timezone.
// The API returns UTC timestamps, sometimes without a trailing "Z" (e.g. "2026-07-30T10:00:00").
// We normalise the value to UTC and then use local Date getters so the toast reflects
// the user's system timezone while keeping the display format unchanged.
const formatOutageDateTime = (value) => {
    if (!value) return "";
    const raw = String(value).trim();
    const hasTimezone = /Z$|[+-]\d{2}:?\d{2}$/.test(raw) || /GMT|UTC/i.test(raw);
    const iso = hasTimezone || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(raw)
        ? raw
        : `${raw}Z`;
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return "";
    const day = date.getDate();
    const month = MONTH_NAMES[date.getMonth()];
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const tz = getUserTimezoneAbbr();
    return `${day} ${month} ${year}, ${hours}:${minutes}${tz ? ` ${tz}` : ""}`;
};

const OutageToast = ({ onClose, message, supportingMessage, outageStartsUtc, outageEndsUtc }) => {
    const startFormatted = formatOutageDateTime(outageStartsUtc);
    const endFormatted = formatOutageDateTime(outageEndsUtc);

    const baseMessage = message || "The EY-Parthenon Data Bureau Submission Portal will undergo scheduled maintenance from";
    const title = (startFormatted && endFormatted)
        ? `${baseMessage} ${startFormatted} to ${endFormatted}.`
        : baseMessage;
    const description = supportingMessage || "The system will be unavailable during this period. Please plan your submissions accordingly.";
    return (
        <MotifToast
            variant="warning"
            className="outage-toast-banner"
            onClose={onClose}
            aria-label="Close maintenance notification"
        >
            <div className="outage-toast-banner__body" role="alert" aria-live="polite">
                <img src={warningIcon} alt="" className="outage-toast-banner__icon" aria-hidden="true" />
                <div className="outage-toast-banner__content">
                    <p className="outage-toast-banner__title">
                        {title}
                    </p>
                    <p className="outage-toast-banner__message">
                        {description}
                    </p>
                </div>
            </div>
        </MotifToast>
    );
};

export default OutageToast;
